import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/today", label: "今日更新" },
  { to: "/rank", label: "热门榜单" },
  { to: "/recommend", label: "编辑推荐" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (kw) navigate(`/today?q=${encodeURIComponent(kw)}`);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="container-x flex h-16 md:h-20 items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="卡通动漫第一页首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50">
            <i className="ri-book-open-fill" style={{ fontSize: "18px" }}></i>
          </span>
          <span className={`font-display text-xl md:text-2xl tracking-wide ${solid ? "text-primary-700" : "text-white"}`}>
            卡通动漫第一页
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((l) => {
            const active = l.to === "/" ? location.pathname === "/" : location.pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : solid
                      ? "text-foreground-800 hover:bg-background-100"
                      : "text-white/90 hover:bg-white/15"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={submitSearch} className="relative" role="search">
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画"
              className={`h-10 w-40 lg:w-52 rounded-full border pl-10 pr-4 text-sm transition-all focus:w-56 lg:focus:w-64 ${
                solid
                  ? "border-background-200 bg-background-100 text-foreground-900 outline-none focus:border-primary-300"
                  : "border-white/30 bg-white/10 text-white placeholder:text-white/70 outline-none focus:border-white/60"
              }`}
              aria-label="搜索漫画"
            />
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-current opacity-60">
              <i className="ri-search-line" style={{ fontSize: "16px" }}></i>
            </span>
          </form>
          <Link
            to="/contact"
            className={`rounded-full px-5 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
              solid
                ? "bg-accent-500 text-foreground-950 hover:bg-accent-600"
                : "bg-accent-400 text-foreground-950 hover:bg-accent-500"
            }`}
          >
            联系我们
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
            solid ? "text-foreground-900 hover:bg-background-100" : "text-white hover:bg-white/15"
          }`}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} style={{ fontSize: "22px" }}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </Link>
            ))}
            <Link to="/contact" className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100">
              联系我们
            </Link>
          </nav>
          <form onSubmit={submitSearch} className="relative mt-3" role="search">
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画"
              className="h-11 w-full rounded-full border border-background-200 bg-background-100 pl-10 pr-4 text-sm outline-none focus:border-primary-300"
              aria-label="搜索漫画"
            />
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400">
              <i className="ri-search-line" style={{ fontSize: "16px" }}></i>
            </span>
          </form>
        </div>
      )}
    </header>
  );
}